module.exports = __webpack_public_path__ + "img/0Q3B7249_WoodMatted_MockedUp.e5484d31.jpg";